import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"
import _reduce from "lodash/reduce"

import ModernModal from "shared/components/ModernModal"
import Typograph from "../../../../../../components/Typograph"
import Description from "../../../Description"

import styles from "./styles.css"

import { maskTel } from "services/utils/mask"

import PlusIcon from "../../../../../../assets/svg/plus-icon.svg"
import MinusIcon from "../../../../../../assets/svg/minus-icon.svg"

const StepLevelCalls = ({
  isCurrentStep,
  onNextStep,
  onPreviousStep,
  onClose,
  t,
  schedule,
  update
}) => {
  const [numberOfCallsReceived, setNumberOfCallsReceived] = useState(0)
  const [schedulingData, setSchedulingData] = useState(schedule.loadRedirect)

  useEffect(() => {
    calculateNumberOfCallsReceived()
  }, [schedulingData])

  const calculateNumberOfCallsReceived = () => {
    const totalCallsReceived = _reduce(
      schedulingData.targetPhoneList,
      (acc, phone) => {
        return acc + Math.floor(phone.percentage) / 10
      },
      0
    )
    setNumberOfCallsReceived(totalCallsReceived)
  }

  const handleAddNumberCallsReceived = (phoneNumber) => {
    if (numberOfCallsReceived < 10) {
      const targetPhoneList = _map(schedulingData.targetPhoneList, (item) => {
        if (item.phoneNumber === phoneNumber && item.percentage < 100) {
          return {
            ...item,
            percentage: item.percentage + 10
          }
        }
        return item
      })

      setSchedulingData((prevState) => ({
        ...prevState,
        targetPhoneList
      }))
    }
  }
  const handleRemoveNumberCallsReceived = (phoneNumber) => {
    if (numberOfCallsReceived > 1) {
      const targetPhoneList = _map(schedulingData.targetPhoneList, (item) => {
        if (item.phoneNumber === phoneNumber && item.percentage > 10) {
          return {
            ...item,
            percentage: item.percentage - 10
          }
        }
        return item
      })
      setSchedulingData((prevState) => ({
        ...prevState,
        targetPhoneList
      }))
    }
  }

  const handleResetNumberOfCallsReceived = () => {
    setSchedulingData(schedule.loadRedirect)
  }

  const handlePrevStep = () => {
    update(schedulingData)
    onPreviousStep()
  }

  const handleNextStep = () => {
    update(schedulingData)
    onNextStep()
  }

  return (
    <ModernModal
      isOpen={isCurrentStep}
      onClose={onClose}
      onCancel={handlePrevStep}
      onConfirm={handleNextStep}
      cancelButtonText="Voltar"
      confirmButtonText="Prosseguir"
    >
      <Typograph htmlTag="h1" size="medium" color="outer_space" weight="bold">
        {t("START_CONFIG")}
      </Typograph>
      <Typograph
        htmlTag="h1"
        size="medium"
        color="outer_space"
        weight="semi-bold"
      >
        {schedulingData.originPhoneNumber}
      </Typograph>
      <Typograph
        htmlTag="h1"
        size="medium"
        color="outer_space"
        weight="semi-bold"
      >
        {t("NIVEL_REDIRECTION_CALLS")}
      </Typograph>
      <Typograph htmlTag="p" size="medium" color="outer_space" weight="medium">
        {t("DESCRIPTION_NIVEL_REDIRECTION_CALLS")}
      </Typograph>
      <div className={styles.quantityClass}>
        <button
          className={styles.resetButtonClass}
          onClick={() => handleResetNumberOfCallsReceived()}
        >
          {t("RESET")}
        </button>
        <Typograph
          htmlTag="span"
          size="small"
          color="outer_space"
          weight="medium"
        >
          {Math.floor(numberOfCallsReceived)}/10
        </Typograph>
      </div>

      <Description className={styles.descriptionContainer}>
        {_map(schedulingData.targetPhoneList, (item) => (
          <div className={styles.numberItemsClass} key={item.phoneNumber}>
            <Typograph
              htmlTag="p"
              size="small"
              color="outer_space"
              weight="bold"
            >
              {maskTel(item.phoneNumber)}
            </Typograph>
            <div className={styles.controlButtonContainer}>
              <button
                disabled={numberOfCallsReceived === 10}
                className={styles.controlButtonClass}
                onClick={() => handleAddNumberCallsReceived(item.phoneNumber)}
              >
                <img src={PlusIcon} alt="Adicionar" />
              </button>
              <button
                disabled={Math.floor(item.percentage / 10) === 1}
                className={styles.controlButtonClass}
                onClick={() =>
                  handleRemoveNumberCallsReceived(item.phoneNumber)
                }
              >
                <img src={MinusIcon} alt="Remover" />
              </button>
            </div>
            <Typograph
              htmlTag="span"
              size="small"
              color="nevada_gray"
              weight="bold"
            >
              {Math.floor(item.percentage / 10)}
            </Typograph>
          </div>
        ))}
      </Description>
    </ModernModal>
  )
}
StepLevelCalls.propTypes = {
  isCurrentStep: PropTypes.boolean,
  onNextStep: PropTypes.func,
  onPreviousStep: PropTypes.func,
  update: PropTypes.func,
  onReset: PropTypes.func,
  t: PropTypes.func,
  onClose: PropTypes.func,
  schedule: PropTypes.object
}
export default StepLevelCalls



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/StepModals/components/StepLevelCalls/index.js